<template>
  <!-- Section START-->
  <section class="py-5 bg-light">
    <div class="container px-5 my-5">
      <div class="row g-5">
        <div class="col-lg-6 text-center" data-aos="fade-up" data-aos-delay="500"><img class="position-sticky mx-auto img-fluid rounded mb-5 mb-lg-0" src="@/assets/img/medi-tshirt.jpeg" style="top:100px;" alt="..." /></div>
        <div class="col-lg-6">
          <h2 class="mb-5" data-aos="fade-up" data-aos-delay="500">Wer bin ich?</h2>
          <div  data-aos="fade-up" data-aos-delay="500">
            <p class="lead fw-normal text-dark mb-3">Seit Ende der 80 er Jahre ist Rock meine große musikalische Leidenschaft. Während meine Freunde sich in den Kneipen und Lokalen vergnügten, war ich Stammgast in Discotheken.</p>
            <p class="lead fw-normal text-dark mb-3">Dadurch hat sich meine umfangreiche Musiksammlung stark vergrößert, so konnte ich jedem Event gerecht werden.</p>
          </div>
          <div data-aos="fade-up" data-aos-delay="500">
            <p class="lead fw-normal text-dark mb-3">Damit habe ich bereits erfolgreich in den Jahren 1993 – 2008 als DJ die Gäste unterhalten.</p>
            <p class="lead fw-normal text-dark mb-3">Aus familiären Gründen, durch die Geburt meiner Tochter, haben sich neue Prioritäten ergeben.</p>
          </div>
        <div data-aos="fade-up" data-aos-delay="500">
            <p class="lead fw-normal text-dark mb-3">Anfang 2014 habe ich mir den Entschluss gefasst wieder einzusteigen und habe mein Repertoire wieder auf die neuesten Trends und Anforderungen angepasst.</p>
            <p class="lead fw-normal text-dark mb-3">Damit führe ich jetzt die verschiedensten Events von Hochzeiten, über Familienfeiern/Geburtstage, bis zu allen möglichen Veranstaltungen auf Firmenebene durch.</p>
            <p class="lead fw-normal text-dark mb-0">Von 20 bis 1200 Gästen konnte ich mit meiner über 25-jährigen Erfahrung damit begeistern.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Section END-->
</template>

<script setup>
</script>

<style scoped>
</style>